import { render, staticRenderFns } from "./MyService.vue?vue&type=template&id=527cd0e1&scoped=true&"
import script from "./MyService.vue?vue&type=script&lang=ts&"
export * from "./MyService.vue?vue&type=script&lang=ts&"
import style0 from "./MyService.vue?vue&type=style&index=0&id=527cd0e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527cd0e1",
  null
  
)

export default component.exports